import React from "react";
import { motion } from "framer-motion";

const PERKS = [
  {
    n: "01",
    title: "A Legacy in Print",
    body: "Your brand's definitive journey, beautifully crafted by elite biographers and meticulously fact-checked. Immortalized in a premium hardcover edition designed to command attention and outlast a lifetime of standard marketing campaigns.",
  },
  {
    n: "02",
    title: "The Ultimate Media Kit",
    body: "Gain complete, unrestricted access to your custom chapter, cinematic episode highlights, and exclusive \"Featured Leader\" media badges. Seamlessly amplify these assets across your own channels with our team's comprehensive promotional backing.",
  },
  {
    n: "03",
    title: "A Cinematic Broadcast Feature",
    body: "A premium, studio-grade interview experience spotlighting your journey as a visionary founder. This beautifully directed broadcast feature is designed to captivate audiences, elevate your executive profile, and position your brand at the absolute pinnacle of the industry.",
  },
];

export default function WhatYouGet() {
  return (
    <section
      id="what-you-get"
      data-testid="what-you-get-section"
      className="relative bg-cream py-16 lg:py-24"
    >
      <div className="max-w-[1400px] mx-auto container-x">
        {/* eyebrow */}
        <div className="flex items-center gap-4 mb-14">
          <span className="font-mono text-[10px] tracking-[0.28em] text-burgundy">WHAT YOU GET</span>
          <span className="flex-1 h-px bg-line" />
        </div>

        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9 }}
          className="font-display font-semibold text-[clamp(2rem,5.2vw,4.2rem)] leading-[1.05] tracking-[-0.015em] text-ink max-w-[22ch] mb-12"
        >
          A single afternoon to chronicle your legacy. A timeless masterclass
          destined to inspire the industry for generations.
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.15 }}
          className="text-[15px] lg:text-[16px] leading-[1.8] text-body max-w-2xl mb-20 lg:mb-24"
        >
          This exclusive feature is reserved entirely for the industry&rsquo;s
          standout leaders. The collaboration is simple: you share your
          milestone achievements, and we provide the expansive, authentic
          reach your success truly deserves&mdash;amplifying your brand to
          heights that usually take years to build.
        </motion.p>

        {/* perks list */}
        <ul className="hair-top">
          {PERKS.map((perk, i) => (
            <motion.li
              key={perk.n}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.08 }}
              data-testid={`perk-${perk.n}`}
              className="hair-bottom grid grid-cols-12 gap-4 lg:gap-10 py-10 lg:py-14 items-start group hover:bg-cream-2/40 transition-colors duration-500 -mx-3 sm:-mx-6 px-3 sm:px-6"
            >
              <div className="col-span-2 lg:col-span-1">
                <span className="font-mono text-[12px] tracking-[0.05em] text-muted-ink">
                  {perk.n}
                </span>
              </div>
              <div className="col-span-10 lg:col-span-5">
                <h3 className="font-display font-semibold text-[1.55rem] lg:text-[1.85rem] leading-tight text-ink">
                  {perk.title}
                </h3>
              </div>
              <div className="col-span-12 lg:col-span-6 lg:pl-4">
                <p className="text-[15px] lg:text-[16px] leading-[1.8] text-body">
                  {perk.body}
                </p>
              </div>
            </motion.li>
          ))}
        </ul>
      </div>
    </section>
  );
}
